module.exports = __webpack_public_path__ + "static/media/sura-minus.c2fa3190.svg";